import React, { useEffect, useState } from "react"
import { Container, Row, Col } from "react-bootstrap"
import HomeNavbar from "../navbars/navbar"
import { Outlet, useLocation, useNavigate } from "react-router-dom"
import isAuthenticated from "../../common/isAuthenticated"
import "../../components/mainWrapper/HeaderNav.css"
import SideBar from "../sidebar/sidebar"
import { IoCloseCircle } from "react-icons/io5"
interface mainWrapperProps {
  isOpen: boolean
  closeNav: () => void
}
const MainWrapper = ({ isOpen, closeNav }: mainWrapperProps) => {
  const isAuthentic = isAuthenticated()
  const [authenticated, setAuthenticated] = useState(false)

  const location = useLocation()
  // useEffect(() => {
  //   setAuthenticated(!!isAuthenticated())
  // }, [isAuthenticated()])

  return (
    <>
      <Container fluid className="px-0">
        <Row className="mx-0">
          <Col className="px-0">
            {!(isAuthentic && location.pathname.includes("dash")) ? (
              <header className="header">
                <HomeNavbar />
              </header>
            ) : null}
          </Col>
        </Row>
        <div>
          {isAuthentic && location.pathname.includes("dash") ? (
            <div className={`sidebar-wrapper ${isOpen ? "open" : ""}`}>
              <IoCloseCircle
                className="close-sidebar d-lg-none"
                onClick={closeNav}
              />
              <SideBar />
            </div>
          ) : null}
          <div
            style={{
              fontFamily: "Exo 2",
            }}
          >
            <Outlet />
          </div>
        </div>
      </Container>
    </>
  )
}

export default MainWrapper
